import { createContext, useContext } from "react";

export const PageDataContext = createContext(null);

export const usePageData = () => {
    const result = useContext(PageDataContext);

    return result;
}